export default __webpack_public_path__ + "photo-camera.png";